import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiGet } from '../../../../api';
import { API_BASE_URL } from '../constants/consts';
import { authFirewallQueryKeys } from '../constants/queryKeys';
import type { ApiError } from '../types';

const END_POINT = '/configuration';

export type AuthenticationFirewallConfiguration = {
    authFilters: {
        userType: number[];
        excludeDirectoryTypes: string[];
        excludeUserGuids: string[];
    };
};

const fetchConfiguration = async (): Promise<AuthenticationFirewallConfiguration> => {
    return await apiGet<AuthenticationFirewallConfiguration>(`${API_BASE_URL}${END_POINT}`);
};

export const useConfiguration = (): UseQueryResult<AuthenticationFirewallConfiguration, ApiError> => {
    return useQuery({
        queryKey: authFirewallQueryKeys.configuration(),
        queryFn: () => fetchConfiguration()
    });
};

